export default __webpack_public_path__ + "media/images/enlarge-8037d035c749c5e0ce0db83825ef6388.svg";